let emailPreviewTextItems = [
  {
    countryCode: 'cz',
    fraseFirst: 'Dobrý den ',
    fraseSecond: 'Uvidíme se ve studiu!',
    fraseThird: 'Tým produb',
    subject: 'subject',
    footer1: 'Tento e-mail jste obdržel/a, protože jste součástí produb komunity.',
    footer2: 'Iyuno-SDI Czech Republic s.r.o., Budějovická 778, 140 00 Praha 4, Česká republika',
    footer3: 'Tento e-mail byl vygenerován automaticky, neodpovídejte na něj.',
    footer4: 'Pokud nás chcete kontaktovat, napište nám na '
  },
  {
    countryCode: 'dk',
    fraseFirst: 'Hej ',
    fraseSecond: 'Vi ses i studiet!',
    fraseThird: 'Produb-teamet',
    subject: 'subject',
    footer1: 'Du modtager denne mail, fordi du er en del af produb-fællesskabet.',
    footer2: 'SDI Media A/S, Dortheavej 4, DK-2400 København, Danmark',
    footer3: 'Denne mail kan ikke besvares.',
    footer4: 'Kontakt os på  '
  },
  {
    countryCode: 'fi',
    fraseFirst: 'Hei ',
    fraseSecond: 'Nähdään studiossa!',
    fraseThird: 'Produb-tiimi',
    subject: 'subject',
    footer1: 'Sait tämän sähköpostin, koska olet produb-yhteisön jäsen.',
    footer2: 'SDI Media, Hiomotie 6, 00380 Helsinki, Suomi',
    footer3: 'Tämä on automaattinen viesti. Älä vastaa tähän.',
    footer4: 'Jos haluat ottaa meihin yhteyttä, lähetä sähköpostia osoitteeseen  '
  },
  {
    countryCode: 'it',
    fraseFirst: 'Ciao ',
    fraseSecond: 'Ci vediamo in studio!',
    fraseThird: 'Il team di produb',
    subject: 'subject',
    footer1: 'Hai ricevuto questa e-mail perché fai parte della comunità di produb.',
    footer2: 'SDI Media, Viale Castrense, 12, 00182 Roma, Italia',
    footer3: 'Questa e-mail è stata generata automaticamente, si prega di non rispondere.',
    footer4: 'Se volete contattarci, scriveteci a '
  },
  {
    countryCode: 'no',
    fraseFirst: 'Hei ',
    fraseSecond: 'Ha en fin dag!',
    fraseThird: 'Produb-teamet',
    subject: 'subject',
    footer1: 'Du mottar denne e-posten fordi du er en del av produb-fellesskapet.',
    footer2: 'SDI Media, Sandakerveien 24 C, Bygning E1, 0473 Oslo, Norge',
    footer3: 'Denne e-posten kan ikke besvares.',
    footer4: 'Kontakt oss på  '
  },
  {
    countryCode: 'pl',
    fraseFirst: 'Cześć, ',
    fraseSecond: 'Do zobaczenia w studiu!',
    fraseThird: 'Zespół produb',
    subject: 'subject',
    footer1: 'Otrzymujesz ten e-mail ponieważ należysz do społeczności produb.',
    footer2: 'Iyuno Poland, Postępu 6, 02-676 Warszawa, Polska',
    footer3: 'Wiadomość została wygenerowana automatycznie, prosimy na nią nie odpowiadać.',
    footer4: 'Jeśli masz ochotę skontaktować się z nami, napisz na adres '
  }
]

const SELECTED_COUNTRY_CODE = 'selectedCountryCode'

// ----------------------------------

export function getEmailTextByCountryCode(subcommunityCode){
  let countryCode = localStorage.getItem(SELECTED_COUNTRY_CODE);
  if(subcommunityCode){
    return emailPreviewTextItems.find((item) => item.countryCode==subcommunityCode);
  }else{
      return emailPreviewTextItems.find((item) => item.countryCode==countryCode);
  }
}
